
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface Category {
  id: string;
  name: string;
  description?: string;
}

interface SelectedCategoriesProps {
  selectedCategories: string[];
  categoryMap: Record<string, Category>;
  onRemoveCategory: (categoryId: string) => void;
}

export default function SelectedCategories({
  selectedCategories,
  categoryMap,
  onRemoveCategory
}: SelectedCategoriesProps) {
  if (selectedCategories.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {selectedCategories.map(categoryId => (
        categoryMap[categoryId] && (
          <Badge key={categoryId} variant="secondary" className="gap-1 px-2 py-1">
            {categoryMap[categoryId].name}
            <button 
              type="button"
              onClick={() => onRemoveCategory(categoryId)}
              aria-label={`Remove ${categoryMap[categoryId].name}`}
            >
              <X size={14} />
            </button>
          </Badge>
        )
      ))}
    </div>
  );
}
